// src/services/auth.js

import axios from 'axios'

// Create a base API URL - make sure it's using the environment variable
const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000/api'
console.log('API URL:', API_URL) // Debug log to verify the URL is correct

// Create axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Add a request interceptor to include the auth token
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      const tokenType = localStorage.getItem('token_type') || 'bearer'
      config.headers.Authorization = `${tokenType.charAt(0).toUpperCase() + tokenType.slice(1)} ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Add a response interceptor to handle token related errors
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // Clear authentication data
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      
      // Redirect to login page if not already there
      const currentPath = window.location.pathname
      if (!currentPath.includes('/login')) {
        window.location.href = '/login?redirect=' + currentPath
      }
    }
    return Promise.reject(error)
  }
)

// Authentication service
export const authService = {
  // Login user and get token
  async login(credentials) {
    // Use correct login endpoint path - remove /auth prefix if not needed
    const response = await apiClient.post('/login', credentials)
    if (response.data.token) {
      const tokenData = response.data.token
      console.log(tokenData)
      localStorage.setItem('token', tokenData.token)
      localStorage.setItem('token_type', tokenData.type)
      
      if (response.data.user) {
        localStorage.setItem('user', JSON.stringify(response.data.user))
      }
    }
    return response.data
  },

  // Logout user
  logout() {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  },

  // Check if user is logged in
  isLoggedIn() {
    return !!localStorage.getItem('token')
  },

  // Get current user
  getCurrentUser() {
    const user = localStorage.getItem('user')
    return user ? JSON.parse(user) : null
  },

  // Get auth token
  getToken() {
    return localStorage.getItem('token')
  }
}

// Export the axios instance to use for other API calls
export default apiClient